import ESHCPlan from "./ESHCPlan"
import RetirementPlan from "./RetirementPlan"
import SEPPlan from "./SEPPlan"
import SocialSecurityPlan from "./SocialSecurity"
import GroupLifePlan from "./GroupLifePlan"
import PensionPlan from "./PensionPlan"
import MXHCPlan from "./MXHCPlan"
const cardTypes = {
  ESHCPlan,
  RetirementPlan,
  SEPPlan,
  SocialSecurityPlan,
  GroupLifePlan,
  PensionPlan,
  MXHCPlan
}
export default cardTypes
